import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

export const LiteRegRedirect = createAction('[Lite Reg] Redirect', props<{ token: string }>());

export const LiteRegRedirectError = createAction(
    '[Lite Reg] Redirect Error',
    props<{ error: HttpErrorResponse }>(),
);
